import type { ReactNode } from 'react';

/** One secret in the client's card: what it is, the hint, when, and where it stands. */
export const SecretLine = ({
  label,
  hint,
  facts,
  state,
  menu,
}: {
  label: string;
  hint: string;
  facts: string;
  state: ReactNode;
  /** The quiet actions on this one secret, after its state. */
  menu?: ReactNode;
}) => (
  <div className="flex items-center gap-4 border-b border-border-row px-card py-4 last:border-b-0">
    <span className="w-secret-label shrink-0 text-data text-muted">{label}</span>
    <span className="flex min-w-0 flex-1 flex-col gap-1">
      <span className="truncate font-mono text-data text-primary">{hint}</span>
      <span className="font-mono text-micro text-faint">{facts}</span>
    </span>
    <span className="flex shrink-0 items-center gap-2 text-data text-primary">{state}</span>
    {menu}
  </div>
);
